import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import SvgIcon from './SvgIcon';
export default function createSvgIcon(path, displayName) {
  const Component = (props, ref) => /*#__PURE__*/React.createElement(SvgIcon, _extends({
    ref: ref
  }, props), path);

  Component.displayName = `${displayName}Icon`;
  return /*#__PURE__*/React.memo( /*#__PURE__*/React.forwardRef(Component));
}